import type { RequestParams } from '@/shared/api';
import type { GeoZoneItemListParams } from '../model/types';

export const GEO_ZONE_KEYS = {
  all: ['geo-zone'] as const,
  list: (params?: RequestParams) => [...GEO_ZONE_KEYS.all, 'list', params] as const,
  polygonList: () => [...GEO_ZONE_KEYS.all, 'polygon-list'] as const,
  detail: (id: number) => [...GEO_ZONE_KEYS.all, 'detail', id] as const,
  itemList: (params?: GeoZoneItemListParams) => [...GEO_ZONE_KEYS.all, 'item-list', params] as const,
};
